import { scaleScore } from '../scaling';
import { wcpmLookupTable } from '../../values/scales';
import { locales } from '../../../../constants/constants';
import getArmScore from '../getArmScore';

export function generateScore(activity, metricId, scaleId, shouldRound = true, selectedLocale) {
  if(!activity || !activity.scores || (!activity.scores.wcpmScore && metricId !== "ARM")) {
    return null;
  }

  let orfScore = activity.scores.wcpmScore;
  // ORF score is clamped, such that it can't be greater than highest value in lookup table
  // If value is higher than this (currently 300 wcpm), it's likely a bug
  if(orfScore > (wcpmLookupTable.length - 1)) {
    console.log('WARNING: unrealistically high ORF: ', orfScore);
    activity.scores.wcpmScore = wcpmLookupTable.length - 1;
  }
  if(metricId === 'ORF') { // TODO replace with enum
    orfScore = scaleScore(activity.scores.wcpmScore, scaleId,activity);
  }

  // TODO, to add in nwf and spelling:
  /*
  'NWF': activity.scores.nwf,
  'Spelling': activity.scores.spelling,
  */

  // search for "ARM SPANISH SCORES" to find other places where ARM score is determined.
  let arm = getArmScore(activity.student.id, activity, selectedLocale);
  if(activity.type !== 'assessment') {
    arm = activity.scores.currentArmEstimate;
  }

  let scores = {
    'ORF': orfScore,
    'SightRecognition': activity.scores.esriScore,
    'PhonologicalAwareness': shouldRound ? Math.round(activity.scores.phonAwareScore) : activity.scores.phonAwareScore,
    'VocabSize': shouldRound ? Math.round(activity.scores.vocabSize) : activity.scores.vocabSize,
    'ReadingMastery': Math.round(activity.scores.areaScore*10)/10,
    //NOTE: If you're troubleshooting currentArmEstimate directly through the graphQL, it's at activity.scoreEstimates.ARM_estimate - we map it to the scores
    //      attribute elsewhere for convenience.
    'ARM': parseFloat(parseFloat(arm).toFixed(2)),
  }

  if(scores[metricId] || scores[metricId] == 0) {
    return scores[metricId];
  }

  if(!Object.keys(scores).includes(metricId)){
    console.log('error: invalid metricId: ', metricId)
  }

  return null;
}

export default {
  generateScore,
}